export default __webpack_public_path__ + "static/media/icon-arrow-right.40c3c1d7.svg";